import React from 'react';
import { useTranslation } from 'react-i18next';

import { useProductState } from '../store';

const G100206 = () => {
  const { t } = useTranslation();
  const { product } = useProductState();

  if (product.selling_code !== 'G100206') {
    return null;
  }

  return (
    <div className="bg-sand-100 rounded-md space-y-3 p-6">
      <div className="h6 inline-block bg-primary text-white px-2 py-1 rounded-sm">
        {t('G100206.TITLE')}
      </div>

      <p className="text-sm md:text-base">{t('G100206.TEXT')}</p>
    </div>
  );
};

export default G100206;
